/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MoveTasksToCurrentSprintInput = {|
  currentSprintId?: ?string,
  selectedSprintId?: ?string,
  projectId?: ?string,
  projectGroupId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type moveTasksToCurrentSprintMutationVariables = {|
  input: MoveTasksToCurrentSprintInput
|};
export type moveTasksToCurrentSprintMutationResponse = {|
  +moveTasksToCurrentSprint: ?{|
    +projectGroup: ?{|
      +projects: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +tasks: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +sprint: ?{|
                    +id: string
                  |},
                |}
              |}>
            |}
          |}
        |}>
      |}
    |},
    +project: ?{|
      +tasks: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +sprint: ?{|
              +id: string
            |},
          |}
        |}>
      |}
    |},
  |}
|};
export type moveTasksToCurrentSprintMutation = {|
  variables: moveTasksToCurrentSprintMutationVariables,
  response: moveTasksToCurrentSprintMutationResponse,
|};
*/


/*
mutation moveTasksToCurrentSprintMutation(
  $input: MoveTasksToCurrentSprintInput!
) {
  moveTasksToCurrentSprint(input: $input) {
    projectGroup {
      projects(first: 10000) {
        edges {
          node {
            tasks(first: 10000) {
              edges {
                node {
                  id
                  sprint {
                    id
                  }
                }
              }
            }
            id
          }
        }
      }
      id
    }
    project {
      tasks(first: 10000) {
        edges {
          node {
            id
            sprint {
              id
            }
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MoveTasksToCurrentSprintInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "TaskTypeConnection",
  "kind": "LinkedField",
  "name": "tasks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Sprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tasks(first:10000)"
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  (v4/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveTasksToCurrentSprintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MoveTasksToCurrentSprintPayload",
        "kind": "LinkedField",
        "name": "moveTasksToCurrentSprint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:10000)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveTasksToCurrentSprintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MoveTasksToCurrentSprintPayload",
        "kind": "LinkedField",
        "name": "moveTasksToCurrentSprint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:10000)"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "moveTasksToCurrentSprintMutation",
    "operationKind": "mutation",
    "text": "mutation moveTasksToCurrentSprintMutation(\n  $input: MoveTasksToCurrentSprintInput!\n) {\n  moveTasksToCurrentSprint(input: $input) {\n    projectGroup {\n      projects(first: 10000) {\n        edges {\n          node {\n            tasks(first: 10000) {\n              edges {\n                node {\n                  id\n                  sprint {\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    project {\n      tasks(first: 10000) {\n        edges {\n          node {\n            id\n            sprint {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a080ebb9841c8ecb34cd92c2cada2120';

module.exports = node;
